import request from "@/util/index";
//查询所有单位信息
export function getalldw(){
    return request({
        url:`/portal/api/getInforxcl/getInforxcl/getAllDW`,
        method:'get',
        headers: {
            Authorization: 'Basic ' + btoa('hhjt:hhjt')
        }
    })
}

//查询库存组织
export function querykczz(dwid){
    return request({
        url:`/portal/api/zdweb/zdweb`,
        method:'get',
        headers:{
            Authorization: 'Basic ' + btoa('hhjt:hhjt')
        },
        params:{
            dwid:dwid
        }
    })
}

//查询仓库
export function queryck(dwid){
    return request({
        url:`/portal/api/zdweb/zdweb/queryck`,
        method:'get',
        headers:{
            Authorization: 'Basic ' + btoa('hhjt:hhjt')
        },
        params:{
            dwid:dwid
        }
    })
}
//查询现存量
export function getinforxcl(dwid,kczz,ck,chname,chcode,guige,xinghao,zhujima){

    let params = {
        dwid: dwid,
        kczz: kczz,
        ck: ck,
        chname: chname,
        chcode: chcode,
        guige: guige,
        xinghao: xinghao,
        zhujima:zhujima
    };
    Object.keys(params).forEach(key => (params[key] === null || params[key] === '') && delete params[key]);

    return request({
        url:`/portal/api/getInforxcl/getInforxcl`,
        method:'get',
        headers: {
            Authorization: 'Basic ' + btoa('hhjt:hhjt')
        },
        params: params // 使用过滤后的参数
        // params:{
        //     dwid:dwid,
        //     kczz:kczz,
        //     ck:ck,
        //     chname:chname,
        //     chcode:chcode,
        //     guige:guige,
        //     xinghao:xinghao
        // }
    })
}




/***
 * cliT 二维码样式     使用   B500   样式
 * cliD 扫出来的链接或信息
 * return_file=base64
 * cliF1 仓库代号
 * cliF2 区域信息：A
 * cliF3 仓位编码：Testck001-B-002-00001
 * cliF4 仓库地址：山东省日照市莒县日照东路1号海汇集团北门1号门
 * cliF5
 * cliF6
*/

export function getCaoliao(clid,clif1,clif2,clif3,clif4,clif5){
    return request({
        url:`https://open-api.cli.im/cli-open-platform-service/v1/labelStyle/create?cliT=B500&cliD=${clid}&return_file=base64&cliF1=${clif1}&cliF2=${clif2}&cliF3=${clif3}&cliF4=${clif4}&cliF5=${clif5}`,
        method:'get'
    })
}